// removed by extract-text-webpack-plugin
module.exports = {"total-stock-left-field":"src-modules-accommodation-__TotalStockLeftField__total-stock-left-field--3IXct"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/TotalStockLeftField.less
// module id = 1874
// module chunks = 0